// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-007a4c2f]{font-weight:700;word-break:keep-all;margin-left:1rem}.true[data-v-007a4c2f]{color:var(--true-color)}.false[data-v-007a4c2f]{color:var(--false-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
